/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedPublicLeak
 */
export interface PatchedPublicLeak {
    /**
     * 
     * @type {number}
     * @memberof PatchedPublicLeak
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicLeak
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicLeak
     */
    password?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedPublicLeak
     */
    source?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicLeak
     */
    readonly sourceName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedPublicLeak
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedPublicLeak
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedPublicLeak
     */
    foundDate?: Date | null;
}

/**
 * Check if a given object implements the PatchedPublicLeak interface.
 */
export function instanceOfPatchedPublicLeak(value: object): value is PatchedPublicLeak {
    return true;
}

export function PatchedPublicLeakFromJSON(json: any): PatchedPublicLeak {
    return PatchedPublicLeakFromJSONTyped(json, false);
}

export function PatchedPublicLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedPublicLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'password': json['password'] == null ? undefined : json['password'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceName': json['source_name'] == null ? undefined : json['source_name'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'foundDate': json['found_date'] == null ? undefined : (new Date(json['found_date'])),
    };
}

  export function PatchedPublicLeakToJSON(json: any): PatchedPublicLeak {
      return PatchedPublicLeakToJSONTyped(json, false);
  }

  export function PatchedPublicLeakToJSONTyped(value?: Omit<PatchedPublicLeak, 'id'|'source_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'password': value['password'],
        'source': value['source'],
        'found_date': value['foundDate'] == null ? undefined : ((value['foundDate'] as any).toISOString().substring(0,10)),
    };
}

